//格式化数据
export const formatData = list => {
  if (!Array.isArray(list) || list.length < 1) return []
  return list.map(item => {
    const { subItems, defaultSubItem, ...ot } = item
    const newSubItems = subItems.map(item => {
      return {
        ...item,
        disable: item.stockCount < 1 ? true : false,
      }
    })
    return {
      ...ot,
      subItems: newSubItems,
      defaultSubItem: {
        ...defaultSubItem,
        disable: defaultSubItem.stockCount < 1 ? true : false,
      },
    }
  })
}
